import React,{ useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import "./index.scss";

import SideNav from "../../components/PostLogin/SideNav";
import SideMenu from "../../components/PostLogin/ScanInfo/SideMenu";
import Header from "../../components/PostLogin/ScanInfo/header";

import ScanInfoProvider from "./ScanInfoContext";


const ScanInfo = ({children}) => {

    const location = useLocation();

    const { pathname } = location;

    const queryParams = new URLSearchParams(location.search);
    const customerId = queryParams.get('customer');
    const domainId = queryParams.get('domain');
    const scanId = queryParams.get('scanId');
    const organizationId = queryParams.get('organization');

    const prevDomainIdRef = useRef(null);
    const prevScanIdRef = useRef(null);
    const prevOrganizationIdRef = useRef(null);

    const [menuOpen, setMenuOpen] = useState(true);

    const [reportPage, setReportpage] = useState(false);
    const [triggerStatsFetch, setTriggerStatsFetch] = useState(false);
    const [triggerListFetch, setTriggerListFetch] = useState(false);
    const [contextCurrentPage, setContextCurrentPage] = useState(1);

    const toggleMenuUpdate = (value) => {
        setMenuOpen(value)
    }

    useEffect(() => {
        const splitLocation = pathname.split("/");
        if(splitLocation[2] === "reports") {
            setReportpage(true)
        } else {
            setReportpage(false)
        }
    }, [pathname]);

    useEffect(() => {
        // console.log("organizationId", organizationId, prevOrganizationIdRef.current)
        // console.log("domainId", domainId, prevDomainIdRef.current)
        // console.log("scanid", scanId, prevScanIdRef.current)
        if ((organizationId !== prevOrganizationIdRef.current) ||
            (domainId === prevDomainIdRef.current && scanId !== prevScanIdRef.current) ||
            (domainId !== prevDomainIdRef.current && scanId !== prevScanIdRef.current) ||
            (domainId === prevDomainIdRef.current && scanId === prevScanIdRef.current)) {
            setTriggerStatsFetch(true);
            setContextCurrentPage(1);
        }
    }, [organizationId, domainId, scanId, pathname]);

    useEffect(() => {
        if ((organizationId !== prevOrganizationIdRef.current) ||
            (domainId === prevDomainIdRef.current && scanId !== prevScanIdRef.current && contextCurrentPage === 1) ||
            (domainId === prevDomainIdRef.current && scanId === prevScanIdRef.current) ||
            (domainId !== prevDomainIdRef.current && scanId !== prevScanIdRef.current)) {
            setTriggerListFetch(true);
        }
    }, [organizationId, domainId, scanId, contextCurrentPage, pathname]);

    useEffect(()=>{
        if(domainId !== prevDomainIdRef.current) {
            prevDomainIdRef.current = domainId;
        }        
    },[domainId])

    useEffect(()=>{
        if(organizationId !== prevOrganizationIdRef.current) {
            prevOrganizationIdRef.current = organizationId;
        }        
    },[organizationId])

    useEffect(()=>{
        if(scanId !== prevScanIdRef.current) {
            prevScanIdRef.current = scanId;
        }
    },[scanId])

    return (
        <div className="organization-details-container h-100">
            <SideNav />
            <div className="organization-page-container scan-info-main-container h-100">
                <div className={`scan-info-menu-container position-relative ${menuOpen ? 'active' : ''}`}>
                    <SideMenu toggleMenuUpdate={toggleMenuUpdate}/>
                </div>
                <div className={`scan-info-details-container h-100 ${!menuOpen ? 'active' : ''}`}>
                    <Header />
                    <div className={`page-main-section px-4 py-3 ${reportPage ? 'reports-page' : ""}`}>
                        <ScanInfoProvider 
                            customerId={customerId} 
                            domainId={domainId} 
                            scanId={scanId} 
                            organizationId={organizationId} 
                            triggerStatsFetch={triggerStatsFetch}
                            triggerListFetch={triggerListFetch}
                            setTriggerStatsFetch={setTriggerStatsFetch}
                            setTriggerListFetch={setTriggerListFetch}
                            contextCurrentPage={contextCurrentPage}
                            setContextCurrentPage={setContextCurrentPage}>
                            {children}
                        </ScanInfoProvider>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ScanInfo;